import { copyToClipboard } from 'ui-components'
import { Check, CopyDocument } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import './Copy.scss'

export const CopyText = defineComponent({
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    isRenderCopyText: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isCopySuccess = ref(false)
    const onCopy = () => {
      if (isCopySuccess.value) return
      copyToClipboard(props.value)
      isCopySuccess.value = true
      setTimeout(() => {
        isCopySuccess.value = false
      }, 1000)
    }

    return () => (
      <div class="copy-layout" onClick={onCopy}>
        {props.isRenderCopyText && <span class={'copy-text'}>{props.value}</span>}
        {isCopySuccess.value ? (
          <ElIcon color="var(--colors-up)">
            <Check />
          </ElIcon>
        ) : (
          <ElIcon>
            <CopyDocument />
          </ElIcon>
        )}
      </div>
    )
  },
})
